import { TreeModule } from 'primeng/tree';

import { CommonModule } from '@angular/common';
import { Component, inject, Input, type OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@application/auth/auth.service';
import { Menu } from '@domain/menu/menu';

@Component({
  selector: 'app-menu-tree',
  templateUrl: './menu-tree.component.html',
  styleUrls: ['./menu-tree.component.scss'],
  standalone: true,
  imports: [CommonModule, TreeModule]
})
export class MenuTreeComponent implements OnChanges {
  @Input() items: Menu[] | null = null;
  currentItem: Menu | null = null;
  lastExpanded: Menu | null = null;
  readonly isLogout = 'logout';
  router = inject(Router);
  authService = inject(AuthService);

  ngOnChanges() {}

  /*private expandRecursiveTree(item: Menu) {
    let current: Menu | null = item;
    let parent: Menu | null = null;
    while (!Menu.parentKeyAbsent(current)) {
      if (!current?.parentId) {
        break;
      }
      parent = Menu.searchItem(this.voDataTree, current?.parentId);

      if (parent && parent.children.length > 0) {
        parent.expanded = true;
      }

      current = parent;
    }
  }*/

  /* listenCurrentMenuItem() {
        this.menuService.getCurrentMenuItemObservable().subscribe(currentItem => {
          if (currentItem) {
            this.setMenuItem(currentItem);
            this.expandRecursiveTree(currentItem);
          }
        });
      }
    
      convertTreeData() {
        this.voDataTree = [];
        this.data?.forEach((menuItem: MenuDto) => {
          this.voDataTree.push(Menu.buildTree(menuItem, null));
        });
      }
    
      private expandRecursiveTree(item: Menu) {
        let current: Menu | null = item;
        let parent: Menu | null = null;
        while (!Menu.parentKeyAbsent(current)) {
          if (!current?.parentId) {
            break;
          }
          parent = Menu.searchItem(this.voDataTree, current?.parentId);
    
          if (parent && parent.children.length > 0) {
            parent.expanded = true;
          }
    
          current = parent;
        }
      }
    
      expandItem(item: Menu) {
        if (this.lastExpanded && this.lastExpanded !== item && item.root) {
          this.lastExpanded.expanded = false;
        }
    
        if (item.root) {
          this.lastExpanded = item;
        }
    
        item.expanded = !item.expanded;
      }
    
      setMenuItem(currentItem: Menu) {
        if (currentItem.children.length > 0) {
          return;
        }
        const previous = this.currentItem;
        const isEquals = previous && previous === currentItem;
    
        if (!isEquals && previous) {
          this.unmarkActiveItem(previous);
          previous.actived = false;
          previous.expanded = false;
        }
    
        if (currentItem?.children.length > 0) {
          this.expandItem(currentItem);
        }
    
        if (currentItem?.children.length === 0) {
          currentItem.actived = true;
          this.markActiveItem(currentItem);
          this.menuService.setCurrentMenuItem(currentItem);
        }
    
        this.currentItem = currentItem;
        if (currentItem.url === this.isLogout) {
          // this.authService.logout().subscribe();
        } else if (currentItem.url.includes('http')) {
          window.open(currentItem.url, '_blank');
        } else {
          this.router.navigate([currentItem.url]);
        }
      }
    
      markActiveItem(currentItem: Menu) {
        let found = Menu.searchItem(this.voDataTree, currentItem.id);
        if (found) {
          found.actived = true;
        }
      }
    
      unmarkActiveItem(item: Menu) {
        let found = Menu.searchItem(this.voDataTree, item.id);
        if (found) {
          found.actived = false;
        }
      }
    
      ngOnChanges() {
        if (this.data) {
          this.convertTreeData();
        }
      }*/

  setMenuItem(currentItem: Menu) {
    if (currentItem.children.length > 0) {
      return;
    }
    const previous = this.currentItem;
    const isEquals = previous && previous === currentItem;

    if (!isEquals && previous) {
      this.unmarkActiveItem(previous);
      previous.actived = false;
      previous.expanded = false;
    }

    if (currentItem?.children.length > 0) {
      this.expandItem(currentItem);
    }

    if (currentItem?.children.length === 0) {
      currentItem.actived = true;
      this.markActiveItem(currentItem);
      // this.menuService.setCurrentMenuItem(currentItem);
    }

    this.currentItem = currentItem;
    if (currentItem.url === this.isLogout) {
      this.authService.logout();
    } else if (currentItem.url.includes('http')) {
      window.open(currentItem.url, '_blank');
    } else {
      this.router.navigate([currentItem.url]);
    }
  }

  markActiveItem(currentItem: Menu) {
    let found = Menu.searchItem(this.items, currentItem.id);
    if (found) {
      found.actived = true;
    }
  }

  unmarkActiveItem(item: Menu) {
    let found = Menu.searchItem(this.items, item.id);
    if (found) {
      found.actived = false;
    }
  }

  expandItem(item: Menu) {
    if (this.lastExpanded && this.lastExpanded !== item && item.root) {
      this.lastExpanded.expanded = false;
    }

    if (item.root) {
      this.lastExpanded = item;
    }

    item.expanded = !item.expanded;
  }
}
